import { useLanguage } from '../contexts/LanguageContext'

const Education = () => {
  const { language } = useLanguage()
  
  return (
    <div className="pt-16 min-h-screen bg-[#f9f9f9]">
      <div className="max-w-6xl mx-auto px-6 py-24">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">
          {language === 'tr' ? 'Eğitim' : language === 'en' ? 'Education' : 'Образование'}
        </h1>
        <p className="text-lg text-gray-600">
          {language === 'tr' ? 'Eğitim içeriği yakında eklenecek.' : language === 'en' ? 'Education content will be added soon.' : 'Образовательный контент будет добавлен в ближайшее время.'}
        </p>
      </div>
    </div>
  )
}

export default Education

